'use client';

import { useId } from 'react';

/**
 * Namespaces the `id`s an inline SVG defines so two instances of the same mark
 * can coexist.
 *
 * Paint servers (gradients, clip paths, filters) are referenced through
 * `url(#…)`, which is resolved against the whole document — so the ids SVGR
 * hardcodes collide the moment the same mark is on screen twice, as the header
 * logo and the one inside the login dialog are. Chrome tolerates it, but Safari
 * 15 drops the reference when the duplicate unmounts and the gradient-filled
 * paths fall back to black.
 *
 * React pads the counter with characters that are not safe inside a `url(#…)`
 * fragment (`:r0:` before React 19, `«r0»` after), so they are stripped.
 */
export function useSvgIdPrefix(name: string) {
  const id = useId().replace(/[^a-zA-Z0-9]/g, '');

  return `${name}-${id}-`;
}
